/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/

export const PLACEMENT_ID = 'jira-issueview-comment' as const;
